import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'app/services/auth.service';
import { CompanyService } from 'app/services/models/company.service';
import { PdfService } from 'app/services/models/pdf.service';
import { link } from 'fs';
import { ToastrService } from 'ngx-toastr';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { TDocumentDefinitions } from 'pdfmake/interfaces';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-update-pdf',
  templateUrl: './update-pdf.component.html',
  styleUrls: ['./update-pdf.component.scss']
})
export class UpdatePdfComponent implements OnInit {
  public contentHeader = null;

  pdfTitle = null;
  footerDesciption = ``;
  titleDescription = ``;
  description = ``;
  title = "";

  currentDate: string;

  pdf: any = {};

  public selectedFiles: File[] = [];
  fileName: string = 'Logo Seç';

  company: any = {};

  constructor(private activatedRouter: ActivatedRoute, private pdfService: PdfService,
    private companyService: CompanyService,
    private toastService: ToastrService,
    private router: Router,
    public authService: AuthService
  ) {
    this.currentDate = new Date().toLocaleDateString();

  }

  async ngOnInit() {
    this.contentHeader = {
      headerTitle: 'Pdf',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Pdf Listesi',
            isLink: true,
            link: '/admin/pdf'
          },
          {
            name: 'Pdf Güncelle',
            isLink: false
          }
        ]
      }
    }
    this.activatedRouter.params.subscribe(async params => {
      console.log(params);
      await this.getByIdPdf(params['id']);
    });
    await this.getByIdCompany();
  }

  async getByIdCompany() {
    const data = await this.companyService.getByIdCompany(1);
    this.company = data;
    console.log(this.company)
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFiles = [input.files[0]];
      this.fileName = input.files[0].name;
      console.log(this.selectedFiles);
    }
  }

  async getByIdPdf(id) {
    const pdfAuthorization = this.authService.isEndpointStatus('PUT.Updateing.UpdatePdf');
    if (pdfAuthorization) {
      const data = await this.pdfService.getByIdPdf(id);
      this.pdf = data;
      console.log(this.pdf);
      if (this.pdf != null) {
        this.pdfTitle = data.pdfTitle;
        this.title = data.title;
        this.titleDescription = data.titleDescription;
        this.description = data.description;
        this.footerDesciption = data.footer;
      }
    }else{
      this.toastService.error('Erişmeye yetkiniz yok')
    }
  }

  async updatePdf() {
    const data = await this.pdfService.updatePdf(this.pdf.id, this.pdfTitle, this.title, this.titleDescription, this.description, this.footerDesciption, this.selectedFiles);
    if (data.status == true) {
      this.router.navigate(['/admin/pdf'])
      this.toastService.success(data.message);
    } else {
      this.toastService.error(data.message);
    }
  }

  pdfBaslik = [
    { name: "Ürün adı", width: 200, isEye: true },
    { name: "Adet", width: 0, isEye: true },
    { name: "Fiyat", width: 0, isEye: true },
    { name: "Para Birimi", width: 0, isEye: true },
    { name: "Birim", width: 0, isEye: true },
  ];

  pdfUrunler = [
    { name: "Ürün 1 fsaf fsaf fsafa fsaf saf saf asf asfas fgasgagas asdasd", adet: "5", fiyat: "50", birimFiyat: "TL", birim: "Adet" },
    { name: "Ürün 2", adet: "6", fiyat: "45", birimFiyat: "EUR", birim: "KG" },
    { name: "Ürün 3", adet: "7", fiyat: "24", birimFiyat: "USD", birim: "GR" },
    { name: "Ürün 1", adet: "5", fiyat: "50", birimFiyat: "TL", birim: "Adet" },
    { name: "Ürün 2", adet: "6", fiyat: "45", birimFiyat: "EUR", birim: "KG" },
    { name: "Ürün 3", adet: "7", fiyat: "24", birimFiyat: "USD", birim: "GR" },
    { name: "Ürün 1", adet: "5", fiyat: "50", birimFiyat: "TL", birim: "Adet" },
    { name: "Ürün 2", adet: "6", fiyat: "45", birimFiyat: "EUR", birim: "KG" },

  ];

  public getBase64ImageUrl(base64: string, type: string = 'jpeg'): string {
    return `data:image/${type};base64,${base64}`;
  }

  async generatePDF() {
    const documentDefinition: TDocumentDefinitions = {
      content: [
        {
          columns: [
            {
              // First column: Company logo and title
              columns: [
                {
                  image: this.pdf.companyFile64 ? this.getBase64ImageUrl(this.pdf.companyFile64) : '',
                  width: 100,
                  height: 100,
                  margin: [0, 0, 0, 0] // Margin: [left, top, right, bottom]
                },
                {
                  text: this.title,
                  style: 'header',
                  margin: [0, 25, 0, 0], // Adjust the top margin to align with the logo
                  alignment: 'left' // Ensure title is left aligned
                }
              ],
              width: '*', // Allow it to take available space
            },
            // Second column: PDF logo
            this.pdf.files ? {
              image: this.getBase64ImageUrl(this.pdf.base64Image),
              width: 100,
              height: 100,
              alignment: 'right'
            } : { text: '' }
          ],
          columnGap: 10 // Gap between the first and second column
        },
        {
          columns: [
            {
              width: 250,
              stack: [
                { text: this.titleDescription, fontSize: 11 }
              ]
            }
          ]
        },
        {
          columns: [
            {
              stack: [
                { text: "Teklif Verilen Şirket: Deneme", style: 'companyInfo' },
                { text: "Sorumlu Kişi: Ali Veli", style: 'companyInfo' },
                { text: "Telefon No: 4124124123", style: 'companyInfo' },
                { text: "Adres: 1234 Elm Street, Suite 567, Metropolis, NY 12345", style: 'companyInfo' }
              ],
              width: '50%'
            },
            {
              stack: [
                { text: `Tarih: ${this.currentDate}`, style: 'companyInfo', alignment: 'right' },
                { text: "Teklif No: 2024-001", style: 'companyInfo', alignment: 'right' },
                { text: "Ödeme: 30 Gün", style: 'companyInfo', alignment: 'right' }
              ],
              width: '50%'
            }
          ],
          columnGap: 20,
          margin: [0, 10, 0, 20]
        },
        { text: this.description, margin: [0, 0, 0, 15] },
        {
          table: {
            widths: this.pdfBaslik.map(p => p.width || '*'),
            body: [
              this.pdfBaslik.map(title => ({ text: title.name, bold: true, fillColor: "#2980ba", color: "#ffffff" })),
              ...this.pdfUrunler.map(urun => [
                urun.name,
                urun.adet,
                urun.fiyat,
                urun.birimFiyat,
                urun.birim,
              ]),
            ],
          },
          layout: {
            fillColor: function (rowIndex: number, node: any, columnIndex: number) {
              return (rowIndex % 2 === 0) ? '#EAEAEA' : null;
            },
            hLineWidth: function () { return 0.5; },
            vLineWidth: function () { return 0.5; },
            hLineColor: function () { return 'black'; },
            vLineColor: function () { return 'black'; },
          }
        },
      ],
      footer: (currentPage, pageCount) => {
        return {
          stack: [
            { text: `Sayfa ${currentPage} / ${pageCount}`, alignment: 'center', margin: [0, 0, 0, 5] },
            { text: this.footerDesciption, alignment: 'center', margin: [0, 0, 0, 10] }
          ],
          style: 'footer',
          alignment: 'center'
        };
      },
      styles: {
        header: { fontSize: 18, bold: true, margin: [0, 0, 0, 0] }, // Margin adjusted to ensure alignment
        date: { alignment: 'right' },
        subheader: { fontSize: 14, bold: true, margin: [0, 20, 0, 10] },
        footer: { fontSize: 10, margin: [0, 0, 0, 0] },
        listStyle: {
          margin: [0, 0, 0, 20], // Alt margin ekleyebilirsiniz
          alignment: 'left' // Listenin hizalanması
        }
      },
      pageMargins: [40, 60, 40, 60]
    };

    pdfMake.createPdf(documentDefinition).open();
  }



}
